export const isTouchDevice = window.matchMedia('(hover: none)').matches;

export const isProd = import.meta.env.VITE_APP_ETICKET_ENV === 'production';
